import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-more-hor",
  templateUrl: "./med-icon-more-hor.component.html",
})
export class MedIconMoreHorComponent extends SvgMixinComponent {}
